import { copyMenuSlice } from './CopyMenuSlice';

export const { acknowledgeDataDeletion, selectLocation, validate, resetCopyMenuState } = copyMenuSlice.actions;
